import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { AppService, ShopifyService } from '../services'

@Injectable({
	providedIn: 'root',
})
export class TokenResolver implements Resolve<any> {
	constructor(
		private shopifyService: ShopifyService,
		private appService: AppService,
		private router: Router,
		@Inject(DOCUMENT) private document: Document,
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
		const params = route.queryParams
		if (environment.production && window.location.href.includes('/api/shopify/init')) {
			if (window.location.hostname.includes('ui.')) {
				window.location.href = window.location.href.replace('ui.', '')
				return
			}
		}
		try {
			const userId = params.shop || params.store || window.localStorage.getItem('store')
			if (userId) {
				window['intercomSettings'] = {
					app_id: 'wcsaihd7',
					user_id: userId,
					'Mercury user': true,
				}
				if (window['Intercom']) {
					window['Intercom']('boot', window['intercomSettings'])
				}
			}
		} catch (err) {
			console.log(err)
		}
		if (params.session) {
			window.localStorage.removeItem('store')
			window.localStorage.setItem('store', params.shop || params.store)
			this.document['mercuryStore'] = params.shop || params.store
			return this.shopifyService
				.exchangeSessionForJwt(params.session, params.shop || params.store)
				.toPromise()
				.then((token) => {
					if (params.shop || params.store) {
						this.document[`${params.shop + '-currentToken' || params.store}-currentToken`] = JSON.stringify(token)
						try {
							window.localStorage.setItem(
								params.shop + '-currentToken' || params.store + '-currentToken',
								JSON.stringify(token),
							)
						} catch {
							console.log('localstorage not available')
						}
					}
					if (params.reinstall) {
						this.appService.reauthorize()
					}
					if (params.shop || params.store) {
						this.shopifyService.storeUrl = params.shop || params.store
					}
					if (state.url.includes('api/admin/product') && params.id) {
						this.router.navigate(['/product/' + params.id])
					}
					return token
				})
				.catch((err) => {
					console.error(err)
					return null
				})
		}
		return null
	}
}
